import mainStyle from "./mainStyle.module.scss";
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

//component
import MspLevel from "./components/mspLv";
import ManageOrgLevel from "./components/manageOrgLv";
import SiteLevel from "./components/siteLv";

const RealmSetting = () => {
  
  const location = useLocation();
  const url = location.pathname;

  const [layer, setLayer] = useState(null)
  useEffect(() => {
    let nowSelectedBread = JSON.parse(
      localStorage.getItem("selectBreadcrumbs") || "{}"
    );

    if(url.startsWith("/site/settings")){
      setLayer('site')
    }else if(url.startsWith("/msp/settings")){
      setLayer('msp')
    }else{
      if(!nowSelectedBread.realm.hasManageOrg){
        setLayer('msp') // alone org 於麵包屑層級歸在msp
      }else{
        setLayer('manageOrg')
      }
    }

  }, []);

  return (
      <>
        <div className={mainStyle["mainArea"]}>
          {/* <Grid container style={{justifyContent:'space-between', marginBottom:'10px'}}> */}
            {layer === 'msp' && <MspLevel  />}
            {layer === 'manageOrg' && <ManageOrgLevel />}
            {layer === 'site' && <SiteLevel/>}
          {/* </Grid> */}
        </div>
      </>
  );
};

export default RealmSetting;